import { Alert, CloseButton } from "react-bootstrap";

const SaveAlert = (props) => {
    return (
        <Alert key={props.variant} variant={props.variant}>
          {props.message} <CloseButton onClick={props.closeAlert} style={{float:"right"}}/>
        </Alert>
    )
}
export default SaveAlert;